import { createActions, createReducer } from 'reduxsauce';
import { ITracking } from 'models/Tracking';

export const { Types, Creators } = createActions({
  setTracking: ['data'],
});

const INITIAL_STATE: ITracking = {};

const setTracking = (state = INITIAL_STATE, action: any) => ({
  ...action.data,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_TRACKING as any]: setTracking,
});
